import { render, staticRenderFns } from "./LookupAddresses.vue?vue&type=template&id=2f4d77e8&scoped=true"
import script from "./LookupAddresses.vue?vue&type=script&lang=ts"
export * from "./LookupAddresses.vue?vue&type=script&lang=ts"
import style0 from "./LookupAddresses.vue?vue&type=style&index=0&id=2f4d77e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d77e8",
  null
  
)

export default component.exports